import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers';

export const localStorage = createLocalStorageProvider('jira_business_common');
